import protein1 from "../../assets/protein1.png";
import protein2 from "../../assets/protein2.png";
import protein3 from "../../assets/protein3.png";
import protein4 from "../../assets/protein4.png";
import protein5 from "../../assets/protein5.png";
import protein6 from "../../assets/protein6.png";
import protein7 from "../../assets/protein7.png";

import creatine1 from "../../assets/creatine1.png";
import creatine2 from "../../assets/creatine2.png";
import creatine3 from "../../assets/creatine3.png";
import creatine4 from "../../assets/creatine4.png";
import creatine5 from "../../assets/creatine5.png";
import creatine6 from "../../assets/creatine6.png";

import preworkout1 from "../../assets/preworkout1.png";
import preworkout2 from "../../assets/preworkout2.png";
import preworkout3 from "../../assets/preworkout3.png";
import preworkout4 from "../../assets/preworkout4.png";
import preworkout5 from "../../assets/preworkout5.png";

const shopData = [
  {
    id: 1,
    img: protein1,
    name: "Advanced Whey Protein 750g",
    price: "23.99",
    category: "Protein",
    isNew: true,
  },
  {
    id: 2,
    img: protein2,
    name: "Protein Max 850g",
    price: "16.49",
    category: "Protein",
    isNew: true,
  },
  {
    id: 3,
    img: protein3,
    name: "Whey Pro Elite 2100g",
    price: "51.99",
    category: "Protein",
  },
  {
    id: 4,
    img: protein4,
    name: "PureIsolate Protein 550g",
    price: "9.99",
    category: "Protein",
  },
  {
    id: 5,
    img: protein5,
    name: "Deluxe Protein Blend 750g",
    price: "18.49",
    category: "Protein",
  },
  {
    id: 6,
    img: protein6,
    name: "NitroFuel Protein 1900g",
    price: "39.99",
    category: "Protein",
  },
  {
    id: 7,
    img: protein7,
    name: "OrganicWhey Protein 950g",
    price: "29.99",
    category: "Protein",
  },
  {
    id: 8,
    img: creatine1,
    name: "Platinum Micronized Creatine 450g",
    price: "10.99",
    category: "Creatine",
    isNew: true,
  },
  {
    id: 9,
    img: creatine2,
    name: "Ultra Creatine 350g",
    price: "7.99",
    category: "Creatine",
    isNew: true,
  },
  {
    id: 10,
    img: creatine3,
    name: "Explosive Creatine 550g",
    price: "15.99",
    category: "Creatine",
  },
  {
    id: 11,
    img: creatine4,
    name: "Swedish Pure Creatine 350g",
    price: "10.49",
    category: "Creatine",
  },
  {
    id: 12,
    img: creatine5,
    name: "CellFusion Creatine 2800g",
    price: "62.99",
    category: "Creatine",
  },
  {
    id: 13,
    img: creatine6,
    name: "MuscleBoost Creatine 450g",
    price: "14.99",
    category: "Creatine",
  },
  {
    id: 14,
    img: preworkout1,
    name: "Intensity Pre-Workout 300g",
    price: "15.99",
    category: "Pre-Workout",
    isNew: true,
  },
  {
    id: 15,
    img: preworkout2,
    name: "C4 Ultimate Pre-Workout 350g",
    price: "19.99",
    category: "Pre-Workout",
    isNew: true,
  },
  {
    id: 16,
    img: preworkout3,
    name: "Explosive Pre-Workout 600g",
    price: "16.99",
    category: "Pre-Workout",
  },
  {
    id: 17,
    img: preworkout4,
    name: "PumpMax Pre-Workout 320g",
    price: "18.79",
    category: "Pre-Workout",
  },
  {
    id: 18,
    img: preworkout5,
    name: "Extreme Assault Pre-Workout 420g",
    price: "22.99",
    category: "Pre-Workout",
  },
];

export default shopData;
